import { createContext, useContext } from 'react';

export const WebinyContext = createContext(null);

export const useWebiny = () => useContext(WebinyContext);

export const WebinyProvider = WebinyContext.Provider;
